
import React, { createContext, useContext, useState, useEffect } from 'react';

interface AuthContextType {
  isAuthenticated: boolean;
  login: (password: string) => boolean;
  logout: () => void;
  toggleProviderView: () => void;
  isProviderView: boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [isProviderView, setIsProviderView] = useState<boolean>(false);

  // Check localStorage on initial load
  useEffect(() => {
    const storedAuth = localStorage.getItem('isAuthenticated');
    if (storedAuth === 'true') {
      setIsAuthenticated(true);
    }
    
    const storedProviderView = localStorage.getItem('isProviderView');
    if (storedProviderView === 'true') {
      setIsProviderView(true);
    }
  }, []);

  const login = (password: string): boolean => {
    if (password === 'MFV') {
      setIsAuthenticated(true);
      localStorage.setItem('isAuthenticated', 'true');
      return true;
    }
    return false;
  };

  const logout = () => {
    setIsAuthenticated(false);
    setIsProviderView(false);
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('isProviderView');
  };

  const toggleProviderView = () => {
    const newValue = !isProviderView;
    setIsProviderView(newValue);
    localStorage.setItem('isProviderView', newValue.toString());
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, toggleProviderView, isProviderView }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
